import { useAtomValue } from 'jotai';

import type { PaginatedResponse, PreordersTableRow } from '@ekhodealer/ekho-common';

import { useSearchPreorders } from '../api/useSearchPreorders';
import { preordersBaseParamsAtom } from '../atoms/preordersAtoms';

/**
 * Hook to get facet counts for preorder filter options.
 * Uses base params (without most filters) to show total available options.
 * Raw Algolia facets are keyed by field name (e.g. 'status', 'name').
 */
export function usePreordersFilterFacetCounts(): {
	statusCounts: Record<string, number>;
	modelCounts: Record<string, number>;
	registrationStateCounts: Record<string, number>;
} {
	const baseParams = useAtomValue(preordersBaseParamsAtom);
	const { data } = useSearchPreorders(baseParams);

	const response = data as PaginatedResponse<PreordersTableRow> | undefined;
	const facets = response?.facets as Record<string, Record<string, number>> | undefined;

	return {
		statusCounts: facets?.status ?? {},
		modelCounts: facets?.name ?? {},
		registrationStateCounts: facets?.registrationState ?? {},
	};
}
